export * from './legend.component';
export * from './scale-legend.component';
export * from './legend-entry.component';
export * from './advanced-legend.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/@swimlane/ngx-charts/release/common/legend/index.js
// module id = ../../../../@swimlane/ngx-charts/release/common/legend/index.js
// module chunks = 4